import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { fetchGroupData, fetchGroupMetadata, fetchMyClasses } from './api';
import type { GroupClass, GroupCourse, GroupDepartment, GroupFaculty, Group, GroupFetchParams, GroupInfoFetchParams, GroupSubject } from '@godalming/api-types';

const defaultGroupsStaleTime = 1000 * 60 * 60; // 1 hour

export const groupsQueryOptions = (params: GroupFetchParams ) =>
    queryOptions<Group[]>({
        queryKey: ['groups', params],
        queryFn: () => fetchGroupData(params),
        staleTime: defaultGroupsStaleTime,
    })

export function useGroups(params: GroupFetchParams) {
    return useQuery(groupsQueryOptions(params))
}

export function useGroupsSuspense(params: GroupFetchParams) {
    return useSuspenseQuery(groupsQueryOptions(params))
}

export function myClassesQueryOptions() {
    return queryOptions<GroupClass[]>({
        queryKey: ['myClasses'],
        queryFn: () => fetchMyClasses(),
    })
}

export function useMyClasses() {
    return useQuery(myClassesQueryOptions())
}

export function useMyClassesSuspense() { 
    return useSuspenseQuery(myClassesQueryOptions()) 
}

export function facultyQueryOptions(params: GroupInfoFetchParams) {
    return queryOptions<GroupFaculty>({
        queryKey: ['faculty', params],
        queryFn: () => fetchGroupMetadata({ ...params, type: 'faculty' }),
        staleTime: defaultGroupsStaleTime,
    })
}

export function useFaculty(params: GroupInfoFetchParams) {
    return useQuery(facultyQueryOptions(params))
}

export function useFacultySuspense(params: GroupInfoFetchParams) { 
    return useSuspenseQuery(facultyQueryOptions(params)) 
}

export function departmentQueryOptions(params: GroupInfoFetchParams) {
    return queryOptions<GroupDepartment>({
        queryKey: ['department', params],
        queryFn: () => fetchGroupMetadata({ ...params, type: 'department' }),
        staleTime: defaultGroupsStaleTime,
    })
}

export function useDepartment(params: GroupInfoFetchParams) {
    return useQuery(departmentQueryOptions(params))
}

export function useDepartmentSuspense(params: GroupInfoFetchParams) { 
    return useSuspenseQuery(departmentQueryOptions(params)) 
}

export function subjectQueryOptions(params: GroupInfoFetchParams) {
    return queryOptions<GroupSubject>({
        queryKey: ['subject', params],
        queryFn: () => fetchGroupMetadata({ ...params, type: 'subject' }),
        staleTime: defaultGroupsStaleTime,
    })
}

export function useSubject(params: GroupInfoFetchParams) {
    return useQuery(subjectQueryOptions(params))
}

export function useSubjectSuspense(params: GroupInfoFetchParams) { 
    return useSuspenseQuery(subjectQueryOptions(params)) 
}

export function courseQueryOptions(params: GroupInfoFetchParams) {
    return queryOptions<GroupCourse>({
        queryKey: ['course', params],
        queryFn: () => fetchGroupMetadata({ ...params, type: 'course' }),
        staleTime: defaultGroupsStaleTime,
    })
}

export function useCourse(params: GroupInfoFetchParams) {
    return useQuery(courseQueryOptions(params))
}

export function useCourseSuspense(params: GroupInfoFetchParams) { 
    return useSuspenseQuery(courseQueryOptions(params)) 
}

export function classQueryOptions(params: GroupInfoFetchParams) {
    return queryOptions<GroupClass>({
        queryKey: ['class', params],
        queryFn: () => fetchGroupMetadata({ ...params, type: 'class' }),
        staleTime: defaultGroupsStaleTime,
    })
}

export function useClass(params: GroupInfoFetchParams) {
    return useQuery(classQueryOptions(params))
}

export function useClassSuspense(params: GroupInfoFetchParams) { 
    return useSuspenseQuery(classQueryOptions(params)) 
}
